/**
 * @generated SignedSource<<c1e3d696268ce80aa051b3a7e68d7882>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsBody_piece$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsNameItem_Piece" | "PieceSettingsBodyEmployeeOnlySection_piece" | "PieceSettingsTempoItem_piece">;
  readonly " $fragmentType": "PieceSettingsBody_piece";
};
export type PieceSettingsBody_piece$key = {
  readonly " $data"?: PieceSettingsBody_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBody_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceSettingsBody_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceSettingsNameItem_Piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceSettingsBodyEmployeeOnlySection_piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceSettingsTempoItem_piece"
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "19e79fa121fcc690d502d289db4a094f";

export default node;
